// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider_with_background{   
    max-width: 100%;
    padding: 60px 20px 40px;
}
.slider_with_background .slider_wrap {
    text-align: center;
    color: #fff;
}
.slider_with_background .slick-dots{
    display: none !important;
}
.slider_with_background .User_name span{
    display: none;
}
.slider_with_background .slider_wrap .Description {   
    font-family: Baskervville,sans-serif;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 1px;
    padding-bottom: 26px;
    position: relative;
   margin: 0 20% ;
}
.seperator{
border-top:2px solid #fff;
    width: 10%;
    margin: 0 auto;
}
.slider_with_background .User_name{ 
    margin: 22px 0px 41px 0px;
    font-family: "Oswald";
    font-size: 20px;
    font-weight: 700;
}
.slider_with_background .slider_wrap .Description:after {
    display: block !important;   
    content: "”";
        left: auto;
        right: -41px;
        top: auto;
        bottom: -17px;
    font-size: 80px;
    font-style: normal;
    line-height: 1;
    position: absolute;
    font-family: Georgia,serif;
    color: #fff;
    font-size: 46px;
}
.slider_with_background .slider_wrap .Description:before{
    display: block !important;
    left: -42px;
    top: -20px;
    content: "“";
    font-size: 80px;
    font-style: normal;
    line-height: 1;
    position: absolute;
    font-family: Georgia,serif;
    color: #fff;
    font-size: 46px;
}
.slider_with_background .slider_wrap .title{
    display: none;
}
.quote_icon {   
        margin: 14px 0px 34px 0px;
        padding: 25px 16px 0px 13px;
        border-style: solid;
        border-width: 1px 1px 1px 1px;
        border-color: #FFFFFF;
        border-radius: 50% 50% 50% 50%;
        width: auto;
        display: inline-block;  
}
.quote_icon h2{  
        color: #FFFFFF;
        font-family: "Georgia", Baskervville;
        font-size: 50px;
        font-weight: 400;
        line-height: 25px;
        letter-spacing: -1px;
        margin-bottom:0px;
}
.slider_without_background{
    text-align: center;
}
.slider_without_background .User_name{
    color: #2d529f !important;
    font-weight: 600 !important;
}
.slider_without_background .Description{
    font-family: Baskervville, sans-serif;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 1px;
    color: #777777;
    margin:0 0 1.25rem;
    margin: 0 2.5% .25rem;
}
.slider_without_background .quote_icon{
display: none;
}
.Description span{
    display:none;
    }
.slider_without_background .Description span{
display:inline-block;
}

.slick-prev:before {
    font-family: "FontAwesome";
    content: "\\f104";
    opacity: 1;
    font-size: 16px;
}
.slick-next:before {
    font-family: "FontAwesome";
    content: "\\f054";
    opacity:1;
    font-size:16px
}
.slick-prev,.slick-next  {
    position: absolute;
    width: 30px !important;
    height: 30px !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 22px;
    margin: 0;
    transform: translateY(-50%);
    background-color: #00a0fc !important;
    border-color: #00a0fc;
    color: #fff;
    z-index: 111;
}
.slick-prev:hover,.slick-next:hover {
    background-color: #007fc9
}
.slider_without_background .slick-dots li{
    margin:0 !important;
}
.slider_without_background .slick-dots li.slick-active button:before{
color: #008fe2 !important;
}
.slider_without_background .slick-dots{
    margin-top:0px !important
}
.slider_without_background .User_name>span{
    display:none
}

.slick-dots li button:before {
    font-size: 6px;
    line-height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 9px;
    background: #00a2f8;
    height: 9px;
    content: '.' !important;
    text-align: center;
    opacity: .25;
    color: #000;
    display: inline-block;
    border-radius: 100px;
}`, "",{"version":3,"sources":["webpack://./src/reviewSlider/review-slider.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;AACjB;AACA;IACI,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;GACnB,cAAc;AACjB;AACA;AACA,yBAAyB;IACrB,UAAU;IACV,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,YAAY;QACR,UAAU;QACV,YAAY;QACZ,SAAS;QACT,aAAa;IACjB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;IACX,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;QACQ,yBAAyB;QACzB,2BAA2B;QAC3B,mBAAmB;QACnB,6BAA6B;QAC7B,qBAAqB;QACrB,8BAA8B;QAC9B,WAAW;QACX,qBAAqB;AAC7B;AACA;QACQ,cAAc;QACd,oCAAoC;QACpC,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;QACpB,iBAAiB;AACzB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;AACA;IACI,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;AACA;AACA,aAAa;AACb;AACA;IACI,YAAY;IACZ;AACJ;AACA,oBAAoB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,UAAU;IACV,eAAe;AACnB;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;IACT;AACJ;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;IACT,2BAA2B;IAC3B,oCAAoC;IACpC,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;AACA;IACI;AACJ;AACA;IACI,mBAAmB;AACvB;AACA;AACA,yBAAyB;AACzB;AACA;IACI;AACJ;AACA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,oBAAoB;AACxB","sourcesContent":[".slider_with_background{   \n    max-width: 100%;\n    padding: 60px 20px 40px;\n}\n.slider_with_background .slider_wrap {\n    text-align: center;\n    color: #fff;\n}\n.slider_with_background .slick-dots{\n    display: none !important;\n}\n.slider_with_background .User_name span{\n    display: none;\n}\n.slider_with_background .slider_wrap .Description {   \n    font-family: Baskervville,sans-serif;\n    font-size: 20px;\n    line-height: 28px;\n    letter-spacing: 1px;\n    padding-bottom: 26px;\n    position: relative;\n   margin: 0 20% ;\n}\n.seperator{\nborder-top:2px solid #fff;\n    width: 10%;\n    margin: 0 auto;\n}\n.slider_with_background .User_name{ \n    margin: 22px 0px 41px 0px;\n    font-family: \"Oswald\";\n    font-size: 20px;\n    font-weight: 700;\n}\n.slider_with_background .slider_wrap .Description:after {\n    display: block !important;   \n    content: \"”\";\n        left: auto;\n        right: -41px;\n        top: auto;\n        bottom: -17px;\n    font-size: 80px;\n    font-style: normal;\n    line-height: 1;\n    position: absolute;\n    font-family: Georgia,serif;\n    color: #fff;\n    font-size: 46px;\n}\n.slider_with_background .slider_wrap .Description:before{\n    display: block !important;\n    left: -42px;\n    top: -20px;\n    content: \"“\";\n    font-size: 80px;\n    font-style: normal;\n    line-height: 1;\n    position: absolute;\n    font-family: Georgia,serif;\n    color: #fff;\n    font-size: 46px;\n}\n.slider_with_background .slider_wrap .title{\n    display: none;\n}\n.quote_icon {   \n        margin: 14px 0px 34px 0px;\n        padding: 25px 16px 0px 13px;\n        border-style: solid;\n        border-width: 1px 1px 1px 1px;\n        border-color: #FFFFFF;\n        border-radius: 50% 50% 50% 50%;\n        width: auto;\n        display: inline-block;  \n}\n.quote_icon h2{  \n        color: #FFFFFF;\n        font-family: \"Georgia\", Baskervville;\n        font-size: 50px;\n        font-weight: 400;\n        line-height: 25px;\n        letter-spacing: -1px;\n        margin-bottom:0px;\n}\n.slider_without_background{\n    text-align: center;\n}\n.slider_without_background .User_name{\n    color: #2d529f !important;\n    font-weight: 600 !important;\n}\n.slider_without_background .Description{\n    font-family: Baskervville, sans-serif;\n    font-size: 20px;\n    line-height: 28px;\n    letter-spacing: 1px;\n    color: #777777;\n    margin:0 0 1.25rem;\n    margin: 0 2.5% .25rem;\n}\n.slider_without_background .quote_icon{\ndisplay: none;\n}\n.Description span{\n    display:none;\n    }\n.slider_without_background .Description span{\ndisplay:inline-block;\n}\n\n.slick-prev:before {\n    font-family: \"FontAwesome\";\n    content: \"\\f104\";\n    opacity: 1;\n    font-size: 16px;\n}\n.slick-next:before {\n    font-family: \"FontAwesome\";\n    content: \"\\f054\";\n    opacity:1;\n    font-size:16px\n}\n.slick-prev,.slick-next  {\n    position: absolute;\n    width: 30px !important;\n    height: 30px !important;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 22px;\n    margin: 0;\n    transform: translateY(-50%);\n    background-color: #00a0fc !important;\n    border-color: #00a0fc;\n    color: #fff;\n    z-index: 111;\n}\n.slick-prev:hover,.slick-next:hover {\n    background-color: #007fc9\n}\n.slider_without_background .slick-dots li{\n    margin:0 !important;\n}\n.slider_without_background .slick-dots li.slick-active button:before{\ncolor: #008fe2 !important;\n}\n.slider_without_background .slick-dots{\n    margin-top:0px !important\n}\n.slider_without_background .User_name>span{\n    display:none\n}\n\n.slick-dots li button:before {\n    font-size: 6px;\n    line-height: 20px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 9px;\n    background: #00a2f8;\n    height: 9px;\n    content: '.' !important;\n    text-align: center;\n    opacity: .25;\n    color: #000;\n    display: inline-block;\n    border-radius: 100px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
